import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { FacilityOrderEditFormCsv } from "application/facility-order/forms";
import { FacilityOrderService } from "application/facility-order/services";
import { FacilityService } from 'application/facility/services';
import { ScheduleService } from 'application/schedule/services';
import { action } from "mobx";
import moment from 'moment';
import { toUTCDate } from 'core/utils';
import _ from 'lodash';

class FacilityOrderEditCsvViewStore extends BaseEditViewStore {
    params = {
        id: this.rootStore.routerStore.routerState.params.id,
    };

    constructor(rootStore) {
        const service = new FacilityOrderService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);

        const id = rootStore.routerStore.routerState.params.id;

        super(rootStore, {
            name: "facility-order",
            id: id,
            Form: FacilityOrderEditFormCsv,
            authorization: 'portalSection.update',
            actions: {
                get: async (id, opts) => {
                    const response = await service.get(id, _.extend(opts, {
                        embed: 'Facility'
                    }));
                    this.form.update(response.data);

                    return response.data;
                },
                update: async resource => {
                    const response = await service.update(resource);

                    return response.data;
                },
                create: async resource => {
                    var file = this.form.fields.get("file").files[0];    
                    resource.file = file;                        

                    const response = await service.createCsv(resource);    
                    return response.data;
                },
            },
            FormClass: FacilityOrderEditFormCsv,
        });

        this.service = new FacilityOrderService(rootStore.application.baasic.apiClient);
        this.scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);

        this.facilityStore = new BaasicDropdownStore({
            filterable: true,
        }, {
            fetchFunc: async (term) => {
                const response = await facilityService.find({
                    searchQuery: term,
                    rpp: 50,
                    inActive: false,
                    isNiko: false
                });
                return response.data.item;
            },
            onChange: async (facility) => {
                this.form.set({ facility: facility });
                await this.getNextDays(facility)
            }
        });
    }
    @action.bound
    async getNextDays(facilityId) {
        let dateFrom = new Date();
        const typeResponse = await this.scheduleService.getTypes();
        var calendarType = _.find(typeResponse.item, { abrv: 'delivery' });
        let params = {
            rpp: 1,
            page: 1,
            sort: 'date|asc',
            dateFrom: moment(dateFrom).add(-6, 'd').format('YYYY-MM-DD'),
            facilityId: facilityId,
            embed: 'Facility,AreaOfCare,FacilityScheduleDates,ParentFacilityScheduleDate',
            calendarTypeId: calendarType.id
        };

        var response = await this.scheduleService.find(params);
        if (response.data.item.length > 0) {
            let dateOfService = response.data.item[0].parentFacilityScheduleDate && response.data.item[0].parentFacilityScheduleDate.dateOfService;
            dateOfService = new Date(new Date(toUTCDate(dateOfService)).setHours(12, 0, 0, 0));
            this.form.$('dateOfService').value = dateOfService;
        }
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('FACILITY_ORDER.CREATE.SUCCESS');
    }

    @action
    setItem(item) {
        this.item = item;
        this.itemInitialized = true;
        this.facilityStore.setValue(item.facility);
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);

            if (!resource.file) {
                this.rootStore.notificationStore.error("FACILITY_ORDER.EDIT.UPLOAD_FILE_ERROR");
            }

            this.rootStore.notificationStore.error(err && err.data ? err.data : "FACILITY_ORDER.EDIT.ERROR");
        }
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);
            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);

            if (!resource.file) {
                this.rootStore.notificationStore.error("FACILITY_ORDER.EDIT.UPLOAD_FILE_ERROR");
            }
            else {
                this.rootStore.notificationStore.error(err && err.data ? err.data : "FACILITY_ORDER.CREATE.ERROR");
            }
        }
    }
}

export default FacilityOrderEditCsvViewStore;
